import type { LinkPreview } from '@avslack/shared';

/**
 * Link-elonezetek.
 *
 * A tartalom KULSO oldalrol jon, ezert kizarolag szovegkent jelenitjuk meg,
 * es a kepet is csak akkor toltjuk be, ha a cim http/https. A bal oldali
 * szincsik koti vizualisan az uzenethez, kartya-keret nelkul - kulonben egy
 * linkes uzenet hangosabb lenne, mint maga a beszelgetes.
 */
/** A link hosztneve - ha a hibas URL-en elbukna, maga az URL. */
function hostOf(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
}

export function LinkPreviews({ links }: { links: LinkPreview[] }) {
  if (links.length === 0) return null;

  return (
    <div className="mt-2 space-y-2">
      {links.map((link) => (
        <a
          key={link.url}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="flex gap-3 rounded-r-control border-l-[3px] border-accent-soft bg-surface-sunken/60 py-2 pl-3 pr-3 transition-colors duration-(--duration-quick) hover:border-accent hover:bg-surface-sunken"
        >
          <div className="min-w-0 flex-1">
            {/* Cim, oldalnev es leiras nelkul a kartya URES lenne, a link pedig nevtelen. */}
            {!link.siteName && !link.title && !link.description && (
              <p className="truncate text-sm font-semibold text-accent">{hostOf(link.url)}</p>
            )}
            {link.siteName && <p className="truncate text-2xs text-ink-faint">{link.siteName}</p>}
            {link.title && (
              <p className="truncate text-sm font-semibold text-accent">{link.title}</p>
            )}
            {link.description && (
              <p className="mt-0.5 line-clamp-2 text-xs text-ink-muted">{link.description}</p>
            )}
          </div>

          {link.imageUrl && (
            <img
              src={link.imageUrl}
              alt=""
              loading="lazy"
              referrerPolicy="no-referrer"
              className="size-16 shrink-0 rounded object-cover"
            />
          )}
        </a>
      ))}
    </div>
  );
}
